import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const RouteChangeTracker = () => {
  const location = useLocation()
  const GA_TRACKING_ID = 'G-LYGT8PKQGV'

  useEffect(() => {
    // gtag 함수가 존재할 때만 실행
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_TRACKING_ID, {
        page_path: location.pathname,
      })
    }
  }, [location]) // location 객체가 변경될 때마다 재실행

  return null
}

export default RouteChangeTracker
